const toTimestamp = (value) => {
  if (value == null) return "";

  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? String(value) : String(timestamp);
};

export const getViewportDatasetKey = (dataId, selectedRange, mapProvider) => {
  if (!dataId) return null;

  const start = selectedRange?.startDate ?? selectedRange?.start_time;
  const end = selectedRange?.endDate ?? selectedRange?.end_time;
  return [mapProvider || "", dataId, toTimestamp(start), toTimestamp(end)].join(":");
};

export const shouldAutoFitViewport = (lastFittedKey, nextDatasetKey) =>
  Boolean(nextDatasetKey && lastFittedKey !== nextDatasetKey);

export const shouldAttachMapListeners = (attachedMap, currentMap) =>
  Boolean(currentMap && attachedMap !== currentMap);

export const shouldCenterOnLatestVehiclePosition = (initialLoad, userHasAdjustedMap, selectedPoint) =>
  (initialLoad || !userHasAdjustedMap) &&
  !(selectedPoint?.is_valid && selectedPoint?.lat && selectedPoint?.lng);

export const attachQiMapManualInteractionListeners = (map, onManualInteraction) => {
  if (!map?.on || typeof onManualInteraction !== "function") return () => {};

  const viewport = map.getViewport?.();
  const onZoomControlClick = (event) => {
    if (event.target?.closest?.(".ol-zoom-in, .ol-zoom-out")) {
      onManualInteraction();
    }
  };

  map.on("pointerdrag", onManualInteraction);
  map.on("dblclick", onManualInteraction);
  viewport?.addEventListener("wheel", onManualInteraction, { passive: true });
  viewport?.addEventListener("click", onZoomControlClick);

  return () => {
    map.un?.("pointerdrag", onManualInteraction);
    map.un?.("dblclick", onManualInteraction);
    viewport?.removeEventListener("wheel", onManualInteraction);
    viewport?.removeEventListener("click", onZoomControlClick);
  };
};
